import photo1 from './project21-1.png';
import photo2 from './project21-2.png';
import photo3 from './project21-3.png';
import photo4 from './project21-4.png';
import photo5 from './project21-5.png';
import photo6 from './project21-6.png';
import photo7 from './project21-7.png';
import photo8 from './project21-8.png';
import photo9 from './project21-9.png';
import photo10 from './project21-10.png';
import photo11 from './project21-11.png';
import photo12 from './project21-12.png';
import photo13 from './project21-13.png';
import photo14 from './project21-14.png';
import photo15 from './project21-15.png';
import photo16 from './project21-16.png';

const project21 = {
  id: 21,
  name: '북우리(BOOKWOORI)',
  team: [
    {
      position: 'FrontEnd Developer',
      names: '성혜린 조아령 정연주',
    },
    {
      position: 'BackEnd Developer',
      names: '황채린 문하영 손민서',
    },
    {
      position: 'UXUI Designer',
      names: '외부 협업',
    },
  ],
  about:
    '책과 우리가 함께하는 등산형 독서 서비스, 북우리. 혼자 책 읽는 개인과 함께 책 읽는 공동체, 모든 독서인이 즐겁고 편하게 독서할 수 있도록. 서비스명 “북우리”는 ‘책(북)’과 ‘우리’가 함께하면 ‘봉우리’를 오를 수 있다는 뜻을 담고 있어요. 혼자서도 독서 취미를 꾸준히 이어갈 수 있도록, 책을 읽고 독서록을 쓰며 나만의 산을 올라 보아요. 친구들과 즐겁게 책을 읽을 수 있도록, 문자·전화로 소통하고 서로 책을 잘 읽고 있는지 겨루며 완독을 향해 등반해요.',
  links: {
    website: 'https://www.bookwoori.site',
    github: 'https://github.com/BookwooriAlpineClub',
  },
  photos: [
    photo1,
    photo2,
    photo3,
    photo4,
    photo5,
    photo6,
    photo7,
    photo8,
    photo9,
    photo10,
    photo11,
    photo12,
    photo13,
    photo14,
    photo15,
    photo16,
  ],
};

export default project21;
